import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const PROJECTS = [
	{
		title: 'Full Kitchen Remodel — Scottsdale',
		tag: 'Kitchen Remodeling',
		desc: 'Complete gut and rebuild of a dated 1990s kitchen. New layout, custom shaker cabinets, quartz waterfall island, under-cabinet LED lighting, and a porcelain tile backsplash. Completed in 14 days.',
		img: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?q=80&w=900&auto=format&fit=crop',
	},
	{
		title: 'Master Bathroom Renovation — Phoenix',
		tag: 'Bathroom Renovation',
		desc: 'Transformed a standard master bath into a spa-style retreat. Walk-in rainfall shower, freestanding soaking tub, large-format marble tile, custom vanity, and heated floor. Turned out stunning.',
		img: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=80&w=900&auto=format&fit=crop',
	},
	{
		title: 'Whole-Home LVP Flooring — Chandler',
		tag: 'Flooring & Tile',
		desc: 'Replaced 2,400 sq ft of mixed carpet and tile with luxury vinyl plank throughout the entire main level and all bedrooms. Clean, modern, durable — and done in just 3 days.',
		img: 'https://images.unsplash.com/photo-1615873968403-89e068629265?q=80&w=900&auto=format&fit=crop',
	},
	{
		title: 'Covered Patio Addition — Gilbert',
		tag: 'Decks & Patios',
		desc: 'Built a 400 sq ft covered patio extension with recessed lighting, an outdoor ceiling fan, built-in seating, and a BBQ island. The homeowners now entertain outdoors year-round.',
		img: 'https://images.unsplash.com/photo-1591825729269-caeb344f6df2?q=80&w=900&auto=format&fit=crop',
	},
	{
		title: 'Interior / Exterior Repaint — Mesa',
		tag: 'Painting',
		desc: 'Full inside-and-out paint refresh on a 1,900 sq ft home. Interior in a modern greige palette with white trim, exterior in a warm sandstone tone with contrasting dark accents. Complete in 5 days.',
		img: 'https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?q=80&w=900&auto=format&fit=crop',
	},
	{
		title: 'Window Replacement — Tempe',
		tag: 'Windows & Doors',
		desc: 'Replaced 18 single-pane aluminum windows with Energy Star certified double-pane vinyl units. Homeowner reported an immediate reduction in utility bills and exterior noise. Completed in 2 days.',
		img: 'https://images.unsplash.com/photo-1527030280862-64139fba04ca?q=80&w=900&auto=format&fit=crop',
	},
];

function Gallery() {
	return (
		<>
			<Helmet>
				<title>Our Work | Project Gallery | A-Z Home Improvement LLC</title>
				<meta name="description" content="Browse photos of completed home remodeling projects from A-Z Home Improvement LLC. Kitchens, bathrooms, flooring, patios, painting, and more across the Phoenix metro area." />
			</Helmet>
			<PageHeader
				title="Our Work"
				subtitle="Real results from real Phoenix-area homeowners. Browse recently completed projects below."
			/>

			<section className="section">
				<div className="container">
					<div className="gallery-grid">
						{PROJECTS.map(p => (
							<div key={p.title} className="gallery-card card fade-up">
								<div className="gallery-img-wrap" style={{ position: 'relative' }}>
									<img src={p.img} alt={p.title} style={{ width: '100%', height: 220, objectFit: 'cover', borderRadius: '8px 8px 0 0', display: 'block' }} />
									<span style={{
										position: 'absolute', top: 10, left: 10,
										background: 'var(--brand)', color: '#fff',
										fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
										letterSpacing: 0.5,
									}}>{p.tag}</span>
								</div>
								<div className="gallery-card-body">
									<h3 style={{ margin: '0 0 6px', fontSize: 16 }}>{p.title}</h3>
									<p className="helper" style={{ margin: 0, fontSize: 13 }}>{p.desc}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Testimonials */}
			<section className="section section-alt">
				<div className="container">
					<div style={{ textAlign: 'center', marginBottom: 28 }}>
						<h2>What Our Clients Say</h2>
						<p className="helper" style={{ maxWidth: 480, margin: '0 auto' }}>Honest reviews from verified Phoenix-area homeowners.</p>
					</div>
					<div className="grid">
						{[
							{ name: 'Jennifer T.', city: 'Scottsdale', quote: 'Robert\'s crew remodeled our kitchen in two weeks. The quality is exceptional — every detail was handled perfectly. Worth every penny and they were an absolute pleasure to work with.' },
							{ name: 'Marcus W.', city: 'Chandler', quote: 'We had our whole downstairs floor replaced and the master bathroom remodeled at the same time. Sandra managed everything flawlessly and the work was done faster than expected.' },
							{ name: 'Patricia M.', city: 'Tempe', quote: 'I got three estimates for our patio project and A-Z was not only the most competitive but the most detailed in what they\'d actually deliver. The patio looks incredible.' },
						].map(t => (
							<div key={t.name} className="card" style={{ padding: '22px 20px' }}>
								<div style={{ color: '#c45c14', fontSize: 24, marginBottom: 8 }}>★★★★★</div>
								<p style={{ margin: '0 0 14px', fontStyle: 'italic', fontSize: 14 }}>"{t.quote}"</p>
								<p style={{ margin: 0, fontWeight: 700 }}>{t.name}</p>
								<p className="helper" style={{ margin: 0, fontSize: 12 }}>{t.city}, AZ</p>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="cta-section">
				<div className="container">
					<h2>Ready to Transform Your Home?</h2>
					<p>Contact us today for a free in-home estimate. No pressure, no obligation.</p>
					<Link to="/contact" className="btn" style={{ fontSize: 15, padding: '12px 28px' }}>Get a Free Estimate</Link>
				</div>
			</section>
		</>
	);
}

export default Gallery;
